import React from "react";
import classes from "./ComparisonIcon.module.css";
import higher_icon from "../../../assests/images/higher_icon.png"
import lower_icon from "../../../assests/images/lower_icon.png";
import equal_icon from "../../../assests/images/equal_icon.png";

const ComparisonIcon = ({ comparisonArray }) => {
  const [status = "", otherScheme = "", value = 0] = comparisonArray;

  const capitaliseFirstLetter = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

  const formattedOtherScheme = capitaliseFirstLetter(otherScheme);
  const formattedValue = value.toLocaleString();

  let icon = null;
  let tooltipText = "";

  switch (status) {
    case "higher":
      icon = higher_icon;
      tooltipText = (
        <>
          This figure is <b>£{formattedValue} higher</b> than the corresponding
          value in the {formattedOtherScheme} scenario.
        </>
      );
      break;
    case "lower":
      icon = lower_icon;
      tooltipText = (
        <>
          This figure is <b>£{formattedValue} lower</b> than the corresponding
          value in the {formattedOtherScheme} scenario.
        </>
      );
      break;
    case "equal":
      icon = equal_icon;
      tooltipText = (
        <>
          This figure is <b>equal</b> to the corresponding value in the{" "}
          {formattedOtherScheme} scenario.
        </>
      );
      break;
    default:
      break;
  }

  return (
    <div className={`${classes.icon} ${classes[`icon-${status}`]}`}>
      {icon && <img src={icon} alt={`${status} icon`} />}
      {icon && <div className={classes.tooltip}>{tooltipText}</div>}
    </div>
  );
};

export default ComparisonIcon;
